export const getCompanyData = (state, companyData, total) => {
	return {
		...state,
		companyData: [...state.companyData, ...companyData],
		total: total,
	};
};

export const setTotal = (state, total) => {
	return {
		...state,
		total: total,
	};
}

export const setCompanyLoader = (state, loaderValue) => {
  return {
    ...state,
    isLoading: loaderValue,
  };
}

export const updateCompanyPost = (state, post) => {
	const companyDataCopy = [...state.companyData];

	companyDataCopy[
		companyDataCopy.findIndex((tPost) => {
		return tPost.id === post.id;
	  })
	] = {
	  ...post,
	};
  
	return {
	  ...state,
	  companyData: companyDataCopy,
	};
}

export const companyPageIncreament = (state) => {
  var newPage = state.page + 1;

  return {
    ...state,
    page: newPage,
  };
}

export const createPostCompany = (state, poll) => {
	var newPollQuestion = Array.from(new Set([poll, ...state.pollQuestion]));

	return {
		...state,
		total: state.total + 1,
		pollQuestion: newPollQuestion,
	};
};

export const clearCompanyData = () => {
	return {
		companyData: [],
		total: "",
		page: 1,
		isLoading: true,
	};
};
